import axios from '../../utils/axios';
import CRUD from './crud'

const tournamentBookings = new CRUD('tournament-bookings', 'superior-judge')

export default Object.assign(
    tournamentBookings,
    {
        reducers: {
            ...tournamentBookings.reducers
        },

        payment: (data) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-bookings/payment`, data, {headers: {
                        'Content-Type': 'multipart/form-data'
                    }})
                } catch (error) {
                    console.error(error);
                }
            };
        },

        report: (id) => {
            return async (dispatch) => {
                try {
                    return axios.get(`/superior-judge/tournament-bookings/${id}/report`, { responseType: 'blob' })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        sendMessage: (id, message) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-bookings/${id}/message`, {message: message})
                } catch (error) {
                    console.error(error);
                }
            };
        },
    }
)
